// Attendance is server-authoritative: no offline success or personal-data cache.
const AttendanceService = {
    async request(url, options = {}) {
        const token = typeof AuthManager !== 'undefined' ? AuthManager.getCsrfToken() : null;
        if (!token) throw new Error('Inicia sesión para consultar o guardar la asistencia.');
        const response = await fetch(url, { ...options, cache: 'no-store',
            headers: { 'Content-Type': 'application/json', 'X-SICAF-CSRF': token } });
        const result = await response.json().catch(() => null);
        if (!response.ok || !result?.success) throw new Error(result?.error || 'No se pudo completar la operación de asistencia.');
        return result;
    },
    async getAttendance(classSessionId, date) {
        const result = await this.request('/api/attendance?classSessionId=' + encodeURIComponent(classSessionId) + '&date=' + encodeURIComponent(date));
        return result.attendance || null;
    },
    async saveAttendance(classSessionId, date, attendanceData) {
        return this.request('/api/attendance', { method: 'POST', body: JSON.stringify({
            classSessionId, date, present: attendanceData.present || [],
            absent: attendanceData.absent || [], justified: attendanceData.justified || []
        }) });
    }
};
window.AttendanceService = AttendanceService;
